/**
 * @typedef {import("../../types/directus").components["schemas"]["ItemsAuthor"]} DirectusAuthor
 * @typedef {import("../../types/directus").components["schemas"]["x-metadata"]} DirectusMeta
 */
import { useQuery } from "@tanstack/react-query";
import { getJson } from "../client";

export function useAuthors(options = {}) {
  return useQuery({
    queryKey: ["authors"],
    /** @returns {Promise<{ data?: DirectusAuthor[]; meta?: DirectusMeta }>} */
    queryFn: async () => {
      const fields = [
        "id",
        "first_name",
        "last_name",
        "avatar",
        "instagram",
        "face",
        "translations.id",
        "translations.languages_code",
        "translations.description",
      ].join(",");

      const params = {
        fields,
        sort: "first_name",
        limit: "100", // Get all authors
      };

      const json = await getJson("/items/Author", params);
      return json; // { data, meta }
    },
    staleTime: 300_000, // 5 minutes
    refetchOnWindowFocus: false,
    ...options,
  });
}

export default useAuthors;
